import { IApplicationState } from '../../types/redux';

export const selectEntityId = (state: IApplicationState) => state.calculator.entityId;
